<div class="container">
  <h4>Вход с помощью аккаунта Google</h4>
  <button mat-stroked-button color="primary" (click)="signIn()">
    <mat-icon>exit_to_app</mat-icon>
    Войти в панель управления
  </button>
</div>
